<!-- /src/components/common/Card/LogoGrid.vue -->
<template>
  <div>
    <div v-if="cards.length > 0" class="card-grid">
      <ul class="card-grid__items">
        <li v-for="(card, index) in cards" :key="index">
          <Card :post="card" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Card from '@/components/common/Card/Logo'

export default {
  data() {
    return {
      noCards: false,
    }
  },
  props: {
    cards: {
      type: [Array, Object],
      required: true,
    },
  },
  components: {
    Card,
  },
}
</script>

<style scoped>
.card-grid {
  margin-bottom: 3rem;

  &__items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
    grid-gap: calc(var(--itemSpacing) / 2);
    /* @media (--desktop-large) {
      grid-gap: var(--itemSpacing-lg);
    } */
  }
}

.loader {
  text-align: center;
  margin-top: 4rem;
  margin-bottom: 4rem;
}
</style>
